<nav class="breadcrumb" aria-label="Breadcrumb">
  <ol class="breadcrumb-list">
    @for (item of breadcrumbs; track item.url ?? item.label; let last = $last) {
    <li class="breadcrumb-item">
      @if (!last && item.url) {
      <a [routerLink]="item.url" class="breadcrumb-link">{{ item.label }}</a>
      } @else {
      <span class="breadcrumb-current">{{ item.label }}</span>
      }
      @if (!last) {
      <span class="breadcrumb-separator">
        <i class="fa-solid fa-chevron-right"></i>
      </span>
      }
    </li>
    }
  </ol>
</nav>
